const SNAPSHOT_PATTERN = /^(\d{4})-(\d{2})-(\d{2})[ T](\d{2}:\d{2})/;

export function formatSnapshotDttm(value: string): string {
  const match = SNAPSHOT_PATTERN.exec(value);

  if (!match) {
    return value;
  }

  const [, year, month, day, time] = match;

  return `${day}.${month}.${year} ${time}`;
}
